import React from 'react';
import { TouchableOpacity } from 'react-native';

import { TOUCHABLE } from '../styleConstants';

import Icon from './Icon';
import Image from './Image';

type Props = {
  hitSlop?: any;
  style?: any;
  onPress: Function;
  name: string;
  size: number;
  color?: string;
  title?: string;
  testID?: string;
  source?: any;
  iconStyle?: any;
};

const IconButton = ({
  source,
  iconStyle,
  onPress,
  style,
  hitSlop,
  name,
  size,
  color,
  title,
  testID,
}: Props) => (
  <TouchableOpacity
    onPress={onPress as any}
    style={[style]}
    hitSlop={{
      top: TOUCHABLE,
      bottom: TOUCHABLE,
      left: TOUCHABLE,
      right: TOUCHABLE,
      ...hitSlop,
    }}
    testID={testID}
  >
    {!source ? (
      <Icon name={name} size={size} color={color} title={title} />
    ) : (
      <Image style={iconStyle} resizeMode="contain" source={source} />
    )}
  </TouchableOpacity>
);

export default IconButton;
